import styled from 'styled-components';

import { spaceL, spaceXL } from '@xing-com/tokens';
import { Headline as InnerHeadline } from '@xing-com/typography';

import { FollowButton as InnerFollowButton } from '../../components/follow-button';

export const Headline = styled(InnerHeadline)`
  margin-top: ${spaceXL};
  margin-bottom: ${spaceL};
`;

export const FollowButton = styled(InnerFollowButton)`
  margin: 0 auto;
`;
